import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
//import { GoogleMap } from 'react-google-maps';
import Geocode from "react-geocode";
import MapContainer from "./Components/MapContainer";
import FolderIcon from "@material-ui/icons/Folder";
import DeleteIcon from "@material-ui/icons/Delete";

import {
    Card,
    CardHeader,
    Avatar,
    Select,
    CardContent,
    MenuItem,
    TextField,
    Button,
    InputLabel,
    Typography,
    FormControl,
    Grid,
    Snackbar,
    SnackbarContent,
    Paper,
    ListItem,
    ListItemAvatar,
    ListItemText,
    IconButton,
    ListItemSecondaryAction,
    List
} from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { dayImg } from "vrcore-dashboard/dist/utilities";
import { nightImg } from "vrcore-dashboard/dist/utilities";
import { connect } from "react-redux";
import { AccountBox } from "@material-ui/icons";
import {
    createJobPack,
    getTemplates,
    getAllUsers,
    getReportTitles,
    uploadFile,
    removeFile,
    getMasterSSWP
} from "./actions";
import {
    selectTemplateList,
    selectAllUsers,
    selectUploadedFiles,
    selectReportTitles,
    selectSSWPList
} from "./selectors";

import "react-day-picker/lib/style.css";

const styles = theme => ({
    "*": {
        transition: ".3s ease-in-out",
        overflow: "visible"
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)"
    },
    bigAvatar: {
        width: "50%",
        height: "auto",
        display: "block",
        margin: "0 auto",
        position: "relative"
    },

    actions: {
        display: "flex"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto"
    },

    icon: {
        width: "auto",
        color: "inherit"
    },
    card: {
        fontSize: 18,
        maxWidth: 345
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },

    button: {
        margin: 10
    },
    textField: {
        margin: 20,
        width: "75%"
    },
    form: {
        margin: 20,
        width: "75%"
    },
    picker: {
        fontSize: "12px"
    },
    paper: {
        padding: 12
    },
    tabTitle: {
        width: "100%",
        boxShadow: "none"
    },
    tabText: {
        color: "white"
    },
    bgGreen: {
        backgroundColor: "green"
    },
    bgAmber: {
        backgroundColor: "orange"
    },
    bgRed: {
        backgroundColor: "red"
    },
    stepContainer: {
        overflow: "visible"
    },
    stepItem: {
        overflow: "visible"
    },
    activeTab: {
        backgroundColor: "rgb(63,81,181)",
        borderRadius: 8,
        color: "white",
        "&:hover": {
            backgroundColor: "rgb(63,81,211)"
        }
    },
    hr: { color: "#bbb", backgroundColor: "#bbb", border: "#bbb" },
    tab: {
        borderRadius: 8,
        color: "grey"
    },
    table: {
        border: "1px solid #cccccc",
        borderRadius: 4
    },
    toggleContainer: {
        height: 56,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: `${theme.spacing.unit}px 0`,
        background: theme.palette.background.default
    }
});

class CreateJobPack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            selectedProfile: false,
            job_pack: {
                location_lat: "",
                location_long: "",
                timestamp: "",
                job_id: "",
                status: "active",
                assigned_manager: "",
                job_name: "",
                assigned_supervisor: "",
                client_name: "",
                assigned_operatives: [],
                address: "",
                deleted: false,
                time_of_day: "Day",
                description_of_works: "",
                start_date: "",
                end_date: "",
                sswp_config_uid: "",
                pdf_1: "",
                job_type: ""
            },
            uploadFileName: false,
            alertOpen: false,
            uuid: [],
            fileSuccess: false,
            fileUploading: false,
            fileProgress: false,

            tabIndex: 0,
            spacing: 16,
            activeStep: 0,
            dense: false,
            secondary: false
        };
        Geocode.setApiKey("AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU");
        props.getTemplates();
        props.getMasterSSWP();
        props.getAllUsers();
        props.getReportTitles();
    }
    componentDidMount() {}
    componentDidUpdate(prevProps, prevState) {
        const { job_pack } = this.state;
        if (prevProps.reportTitles !== this.props.reportTitles) {
            Object.keys(this.props.reportTitles).map((f, i) => {
                if (typeof job_pack[f] === "undefined") {
                    job_pack[f] = "Yes";
                }
                return null;
            });
            this.setState({ job_pack });
        }
    }

    getStepOne() {
        const { job_pack } = this.state;
        const { classes } = this.props;
        const list = this.props.jobTemplates === false ? [] : this.props.jobTemplates;
        const titles = this.props.reportTitles === false ? [] : this.props.reportTitles;
        return (
            <div>
                <Grid container>
                    <Grid item xs={12} md={6} lg={6}>
                        {this.renderTextDetail("Job Name", "job_name")}
                        {this.renderTextDetail("Client Name", "client_name")}
                        <div className={classes.toggleContainer}>
                            <br />
                            <ToggleButtonGroup
                                value={job_pack["time_of_day"]}
                                exclusive
                                onChange={e => {
                                    job_pack["time_of_day"] = e.target.value;
                                    this.setState({ job_pack });
                                }}
                            >
                                <ToggleButton
                                    value="Day"
                                    style={{
                                        background: `url(${dayImg})`,
                                        backgroundSize: "cover",
                                        padding: "3em"
                                    }}
                                >
                                    <div />
                                </ToggleButton>
                                <ToggleButton
                                    value="Night"
                                    style={{
                                        background: `url(${nightImg})`,
                                        backgroundSize: "cover",
                                        padding: "3em"
                                    }}
                                >
                                    <div />
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <FormControl className={classes.form}>
                            <InputLabel>Job Type</InputLabel>
                            <Select
                                key={"job_type"}
                                value={this.state.job_pack.job_type}
                                onChange={val => {
                                    let jobPack = this.state.job_pack;
                                    jobPack.job_type = val.target.value;
                                    Object.keys(list).map((e, i) => {
                                        if (list[e].profile.template_title === val.target.value) {
                                            Object.keys(titles).map((f, i) => {
                                                jobPack[f] = list[e].profile[f];
                                                return f;
                                            });
                                        }
                                        return e;
                                    });
                                    this.setState({
                                        job_pack: jobPack
                                    });
                                }}
                            >
                                {!list && (
                                    <MenuItem value={this.state.index}>
                                        Please Choose a Job Type
                                    </MenuItem>
                                )}
                                {list &&
                                    Object.keys(list).map((e, i) => {
                                        return (
                                            <MenuItem
                                                key={e}
                                                value={list[e].profile.template_title}
                                            >
                                                {list[e].profile.template_title}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <div>
                            <TextField
                                key={"address"}
                                value={job_pack["address"]}
                                label={"Address"}
                                className={classes.textField}
                                onChange={val => {
                                    job_pack["address"] = val.target.value;
                                    this.setState({ job_pack });
                                }}
                            />
                        </div>
                        <div>
                            <Button
                                color="primary"
                                onClick={() => {
                                    if (job_pack["address"].length > 6)
                                        Geocode.fromAddress(job_pack["address"]).then(
                                            response => {
                                                const {
                                                    lat,
                                                    lng
                                                } = response.results[0].geometry.location;
                                                job_pack["location_lat"] = lat;
                                                job_pack["location_long"] = lng;
                                                this.setState({ job_pack });
                                            },
                                            error => {}
                                        );
                                }}
                                variant="contained"
                                className={classes.button}
                            >
                                Find Address on Map
                            </Button>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <div style={{ width: "90%", minHeight: 250 }}>
                            <MapContainer
                                lat={job_pack["location_lat"]}
                                long={job_pack["location_long"]}
                                action={
                                    (this.onMapClick = (e, t, v) => {
                                        Geocode.fromLatLng(v.latLng.lat(), v.latLng.lng()).then(
                                            response => {
                                                job_pack["address"] =
                                                    response.results[0].formatted_address;
                                                job_pack[
                                                    "location_lat"
                                                ] = v.latLng.lat().toString();
                                                job_pack[
                                                    "location_long"
                                                ] = v.latLng.lng().toString();
                                                this.setState({ job_pack });
                                            },
                                            error => {}
                                        );
                                    })
                                }
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
    handleFileUploader = event => {
        Object.keys(event.target.files).map(e => {
            this.props.uploadFile(this.state.job_pack.job_name, event.target.files[e], status => {
                if (status.inProgress) {
                    this.setState({ fileProgress: status.progress });
                } else if (status.finished) {
                    this.setState({ fileSuccess: true, fileProgress: false });
                } else if (status.error) {
                }
            });
            return null;
        });
    };

    handleFileRemove(filename, i) {
        const { job_pack } = this.state;
        this.props.removeFile(this.state.job_pack.job_name, filename, this.props.uploadedFiles, i);
        this.setState({ job_pack });
    }

    getStepTwo() {
        const { classes } = this.props;
        const users = this.props.users === [] ? false : this.props.users;
        return (
            <div>
                <Grid container>
                    <Grid item xs={12} md={6} lg={6}>
                        {this.renderTextAreaDetail(
                            "Brief Description of Works",
                            "description_of_works"
                        )}
                        {this.renderDateDetail("Start Date", "start_date")}
                        {this.renderDateDetail("End Date", "end_date")}
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <FormControl className={classes.form}>
                            <InputLabel>Assigned Supervisor</InputLabel>
                            <Select
                                value={this.state.job_pack.assigned_supervisor}
                                onChange={event => {
                                    let jobPack = this.state.job_pack;
                                    jobPack.assigned_supervisor = event.target.value;
                                    this.setState({
                                        job_pack: jobPack
                                    });
                                }}
                            >
                                {users &&
                                    users.map(e => {
                                        return (
                                            <MenuItem key={e.name} value={e.name}>
                                                {e.name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.form}>
                            <InputLabel>Assigned Manager</InputLabel>
                            <Select
                                value={this.state.job_pack.assigned_manager}
                                onChange={event => {
                                    let jobPack = this.state.job_pack;
                                    jobPack.assigned_manager = event.target.value;
                                    this.setState({
                                        job_pack: jobPack
                                    });
                                }}
                            >
                                {users &&
                                    users.map(e => {
                                        return (
                                            <MenuItem key={e.name} value={e.name}>
                                                {e.name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.form}>
                            <InputLabel>Assigned Operatives</InputLabel>
                            <Select
                                multiple={true}
                                value={this.state.job_pack.assigned_operatives}
                                onChange={event => {
                                    let jobPack = this.state.job_pack;
                                    jobPack.assigned_operatives = event.target.value;
                                    this.setState({
                                        job_pack: jobPack
                                    });
                                }}
                            >
                                {users &&
                                    users.map(e => {
                                        return (
                                            <MenuItem key={e.name} value={e.name}>
                                                {e.name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        );
    }
    getStepThree() {
        const { dense } = this.state;
        const { classes } = this.props;
        const { job_pack } = this.state;
        const files = this.props.uploadedFiles === false ? [] : this.props.uploadedFiles;
        const titles = this.props.reportTitles === false ? [] : this.props.reportTitles;
        return (
            <div>
                <Grid container>
                    <Grid item xs={12} md={6} lg={6}>
                        {titles &&
                            Object.keys(titles).map((f, i) => {
                                return (
                                    <FormControl className={classes.form}>
                                        <InputLabel htmlFor={f}>{titles[f]}</InputLabel>
                                        <Select
                                            key={f}
                                            //label={titles[f]}
                                            value={job_pack[f] || ""}
                                            onChange={val => {
                                                job_pack[f] = val.target.value;
                                                this.setState({ job_pack });
                                            }}
                                            inputProps={{
                                                id: f
                                            }}
                                        >
                                            ><MenuItem value="Yes">Yes</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                        </Select>
                                    </FormControl>
                                );
                            })}
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <div>
                            <FormControl className={classes.form}>
                                {this.state.fileProgress !== false && (
                                    <p
                                        style={{
                                            width: "100%",
                                            background: "orange",
                                            padding: "1em",
                                            color: "white",
                                            fontWeight: "600",
                                            borderRadius: 4
                                        }}
                                    >
                                        File Upload Progress: {this.state.fileProgress}%
                                    </p>
                                )}

                                <input
                                    accept="application/pdf"
                                    multiple
                                    type="file"
                                    onChange={this.handleFileUploader}
                                    style={{ display: "none" }}
                                    ref={fileInput => (this.fileInput = fileInput)}
                                />
                                <Typography>{this.state.uploadFileName}</Typography>
                                <Button
                                    color="primary"
                                    style={{
                                        width: "auto",
                                        display: "inline"
                                    }}
                                    onClick={() => {
                                        this.fileInput.click();
                                    }}
                                    variant="contained"
                                    className={classes.button}
                                >
                                    Select File(s)
                                </Button>
                            </FormControl>
                        </div>
                        <Typography variant="headline" className={classes.title}>
                            Uploaded Files:
                        </Typography>
                        <div>
                            <List dense={dense}>
                                {files &&
                                    files.map((e, i) => {
                                        return (
                                            <ListItem key={i}>
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <FolderIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={e.file} />
                                                <ListItemSecondaryAction>
                                                    <IconButton
                                                        aria-label="Delete"
                                                        onClick={() => {
                                                            this.handleFileRemove(e["file"], i);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        );
                                    })}
                            </List>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
    getSteps() {
        return [
            "General Details & Map Coordinates",
            "Assigned Employees & Time/Date",
            "Forms Included"
        ];
    }
    getStepContent(step) {
        switch (step) {
            case 0:
                return this.getStepOne();
            case 1:
                return this.getStepTwo();
            case 2:
                return this.getStepThree();
            default:
                return "Unknown step";
        }
    }

    handleClickOpen = event => {
        event.preventDefault();
        this.setState({ alertOpen: true });
    };

    handleClose = () => {
        this.setState({
            alertOpen: false
        });
    };
    isActiveTab = id => {
        const { tabIndex } = this.state;
        return tabIndex === id;
    };
    formatDate(key) {
        let DT = this.state.job_pack[key].split("-");

        return `${DT[2]}-${DT[1]}-${DT[0]}`;
    }
    onFormSubmit = () => {
        const { job_pack } = this.state;
        if (typeof job_pack["assigned_operatives"] === "object") {
            job_pack["assigned_operatives"] = job_pack["assigned_operatives"].toString();
        }
        job_pack["location_lat"] = job_pack["location_lat"].toString();
        job_pack["location_long"] = job_pack["location_long"].toString();
        job_pack["start_date"] = this.formatDate("start_date");
        job_pack["end_date"] = this.formatDate("end_date");
        if (typeof this.props.uploadedFiles !== "undefined")
            job_pack["attached_files"] = this.props.uploadedFiles;
        this.setState({ job_pack });
        this.props.createJobPack(this.state.job_pack);
        this.handleClose();
        window.location = "dashboard";
    };
    renderYesNoDetail(label, key) {
        const { job_pack } = this.state;
        const { classes } = this.props;
        return (
            <FormControl className={classes.form}>
                <InputLabel>{label}</InputLabel>
                <Select
                    key={key}
                    value={job_pack[key]}
                    onChange={val => {
                        job_pack[key] = val.target.value;
                        this.setState({ job_pack });
                    }}
                >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                </Select>
            </FormControl>
        );
    }
    renderTextAreaDetail(label, key) {
        const { job_pack } = this.state;
        const { classes } = this.props;
        return (
            <div>
                <TextField
                    key={key}
                    value={job_pack[key]}
                    label={label}
                    multiline={true}
                    rows={2}
                    rowsMax={4}
                    className={classes.textField}
                    onChange={val => {
                        job_pack[key] = val.target.value;
                        this.setState({ job_pack });
                    }}
                />
            </div>
        );
    }
    renderTextDetail(label, key) {
        const { job_pack } = this.state;
        const { classes } = this.props;
        return (
            <div>
                <TextField
                    key={key}
                    value={job_pack[key]}
                    label={label}
                    className={classes.textField}
                    onChange={val => {
                        job_pack[key] = val.target.value;
                        this.setState({ job_pack });
                    }}
                />
            </div>
        );
    }
    renderDateDetail(label, key) {
        const { job_pack } = this.state;
        const { classes } = this.props;
        return (
            <div className={classes.form}>
                <TextField
                    id="date"
                    label={label}
                    type="date"
                    value={job_pack[key]}
                    onChange={event => {
                        job_pack[key] = event.target.value;

                        this.setState({ job_pack });
                    }}
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </div>
        );
    }
    isDisabled() {
        const { job_pack } = this.state;
        const { activeStep } = this.state;

        if (
            activeStep === 0 &&
            (job_pack["job_name"] !== "" &&
                job_pack["client_name"] !== "" &&
                job_pack["address"] !== "")
        ) {
            return false;
        } else if (
            activeStep === 1 &&
            (job_pack["description_of_works"] !== "" &&
                job_pack["start_date"] !== "" &&
                job_pack["end_date"] !== "" &&
                job_pack["assigned_operatives"] !== "" &&
                job_pack["assigned_supervisor"] !== "" &&
                job_pack["assigned_manager"] !== "")
        ) {
            return false;
        } else if (
            activeStep === 2 &&
            (job_pack["vehicle_checklist"] !== "" &&
                job_pack["daily_work_sheet"] !== "" &&
                job_pack["tm_slg_checklist"] !== "")
        ) {
            return false;
        } else {
            return true;
        }
    }
    handleNext = () => {
        this.setState(state => ({
            activeStep: state.activeStep + 1
        }));
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0
        });
    };
    render() {
        const { classes } = this.props;

        return (
            <div>
                <form>
                    <Card>
                        <CardHeader
                            avatar={
                                <Avatar aria-label="Profile-Edit" className={classes.avatar}>
                                    <AccountBox />
                                </Avatar>
                            }
                            title={<Typography variant="headline">Create Jobpack</Typography>}
                        />
                        <CardContent>
                            {this.getStepOne()}
                            {this.getStepTwo()}
                            {this.getStepThree()}
                        </CardContent>
                    </Card>

                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Button
                            color="primary"
                            onClick={this.onFormSubmit}
                            variant="contained"
                            className={classes.button}
                        >
                            Submit
                        </Button>
                        <Button onClick={this.handleReset} className={classes.button}>
                            Reset
                        </Button>
                    </Paper>
                    {/*  */}
                </form>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    autoHideDuration={6000}
                    open={this.state.fileSuccess}
                    onClose={() => {
                        this.setState({ fileSuccess: false });
                    }}
                >
                    <SnackbarContent
                        style={{ backgroundColor: "green", color: "white" }}
                        message="File has been successfully uploaded!"
                    />
                </Snackbar>
            </div>
        );
    }
}
CreateJobPack.propTypes = {
    classes: PropTypes.object.isRequired
};
export default connect(
    store => {
        return {
            jobTemplates: selectTemplateList(store),
            users: selectAllUsers(store),
            reportTitles: selectReportTitles(store),
            uploadedFiles: selectUploadedFiles(store),
            sswpList: selectSSWPList(store)
        };
    },
    {
        createJobPack,
        uploadFile,
        removeFile,
        getTemplates,
        getAllUsers,
        getReportTitles,
        getMasterSSWP
    }
)(withStyles(styles)(CreateJobPack));
